import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipografia',
  templateUrl: './tipografia.component.html',
  styleUrls: ['./tipografia.component.scss']
})
export class TipografiaComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  exampleList = {
    headingMapOk:
      `<h1>Título Principal del Sitio Web</h1>
<h2>Nuestra Entidad</h2>
<h3>Misión y Visión</h3>`,
    headingMaoWrong:
      `<h1>Título Principal del Sitio Web</h1>
<h3>Nuestra Entidad</h3>
<h4>Misión y Visión</h4>`
  };

  constructor() {

    this.arrayComponent = [
      {
        id: 'tipografia',
        titulo: 'Encabezados',
        subtitulo: 'Los títulos o encabezados describen brevemente el tema de la sección que representan. Adicionalmente permiten estructurar la información del sitio cumpliento una jerarquía, como una tabla de contenido.',
        componentRender: `<h1 class="headline-xxl-govco">Headline-xxl</h1>
<h2 class="headline-xl-govco">Headline-xl</h2>
<h3 class="headline-l-govco">Headline-l</h3>
<h4 class="headline-m-govco">Headline-m</h4>
<h5 class="headline-s-govco">Headline-s</h5>
<h6 class="headline-xs-govco">Headline-xs</h6>
`, descripcionList: [
          {
            descripcionComponent: `<h4 class="headline4">Uso de los encabezados</h4>
            <p>Visualmente se percibe la jerarquía de los encabezados a través de su tamaño. En este sentido el título principal es de mayor tamaño respecto a los títulos de menor grado e importancia. </p>
            <p>Sin embargo, otros tipos de usuario, como personas con discapacidad visual, conocen la estructura y la jerarquía al hacer uso correcto de las etiquetas H y su anidamiento. Por lo tanto, siempre se debe iniciar con un encabezado de primer nivel <code>h1</code> y a partir de allí hacer uso de los demás encabezados sin saltarse entre niveles.</p>
            <span class="subtitle-govco">Si es correcto:</span>`,
            descripcionCode:
            `<h1>Título Principal del Sitio Web</h1>
<h2>Nuestra Entidad</h2>
<h3>Misión y Visión</h3>`,
          },
          {
            descripcionComponent:`<span class= "subtitle-govco" >No es correcto: </span>`,
            descripcionCode:
              `<h1>Título Principal del Sitio Web</h1>
<h3>Nuestra Entidad</h3>
<h4>Misión y Visión</h4>
`,
          }
        ]
      },
      {
        id: 'tipografia2',
        titulo: 'Otros elementos de texto',
        subtitulo: 'A continuación se indican los estilos para elementos textuales dentro del sitio como son: Subtítulo, el cual puede ser usado para resaltar textos cortos que no requiera ser un encabezado, párrafos, etiquetas de campos de formulario, leyendas y miga de pan. ',
        componentRender: `<p class="subtitle-govco">Subtítulo</p>
<p class="description-govco">Descripción de sección</p>
<p>Párrafo</p>
<label>Label o etiqueta de un campo de formulario</label>
<span class="small-text-govco">Caption, detalles de un elememto y/o textos descriptivos dentro de un formulario.</span>
`,
      },
    ]

    this.infoComponent = {
      titulo: "Tipografía",
      descripcion: "GOV.CO usa dos tipografías, Montserrat para títulos y descripciones de sección y Work Sans para textos corridos y captions. Estas fuentes pueden ser descargadas directamente en <a href='https://fonts.google.com/' target='_blank' title='Abre en una nueva ventana'>GoogleFonts</a>"
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }
}



